import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareCarBook', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareCarBook/${basketKey}`, request)
}

export {post, put}
